import { render } from "./NowPlaying.vue?vue&type=template&id=9013d636&scoped=true"
import script from "./NowPlaying.vue?vue&type=script&lang=js"
export * from "./NowPlaying.vue?vue&type=script&lang=js"

import "./NowPlaying.vue?vue&type=style&index=0&id=9013d636&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9013d636"]])

export default __exports__